export default __webpack_public_path__ + "static/media/npc_01.85943aad.png";